module.exports = __webpack_public_path__ + "static/get_started_with_us_graphic-6a9c54a69bdf5d928f5e85fea431d662.png";